import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NxModule } from '@nrwl/angular';

import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';

import {
  DateAdapter,
  MAT_DATE_LOCALE,
  MAT_DATE_FORMATS,
  MAT_LABEL_GLOBAL_OPTIONS
} from '@angular/material/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MomentDateAdapter } from '@angular/material-moment-adapter';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers, metaReducers } from './state';

import { ContentModule, ContentService } from '@awp/content';
import { RuntimeConfigLoaderModule, appConfigFactory, RuntimeConfigLoaderService, DEBUG_INJECTION_TOKEN } from '@awp/core/config';
import { CommonUiModule } from '@awp/common';
import { MENU_TOKEN } from '@awp/app-common';
import { ThemeModule, ThemeService } from '@awp/theme';
import { DynamicOutletModule, ModuleLoaderService, DynamicOutletRegistryService } from '@awp/dynamic-outlet';
import { AppConfig } from '@awp/core/config';
import { CardCheckUiModule } from '@awp/nac/card-check/ui';
import { GoogleTagModule } from '@awp/google-tag';

import { AppComponent } from './app.component';
import { ROUTES } from './app.routing';
import { COMPONENTS } from './components';
import { RESPONSE_LOGGER_TOKEN, ResponseConsoleLogger, SirenCache } from '@awp/http';
// import { RESPONSE_LOGGER_TOKEN, ResponseConsoleLogger, SirenCache, SirenMockInterceptor } from '@awp/http';
import { AuthRequestInterceptor } from '@awp/http';

import { DataApiModule, ResponseStoreLogger } from '@awp/data/api';
import {
  CoreNgrxModule,
  RouterStoreModule
} from '@awp/core/ngrx';
import { MY_DATE_FORMATS } from '@awp/core/utils';
import { SharedModule, CmsContentHalService, ThemeHalService, MenuHalService } from '@awp/shared';
import { LayoutModule } from '@awp/layout';
import { AppEffects } from './state/effects';
import { ApFormsModule } from '@awp/forms';
import { environment } from '../environments/environment';
import { SirenCacheNgrx } from '@awp/data/api';
import { COMPONENT_REGISTER, MODULE_REGISTER } from './nac-registry';

library.add(fas);

@NgModule({
  declarations: [AppComponent, ...COMPONENTS],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpClientModule,
    NxModule.forRoot(),
    RouterModule.forRoot(ROUTES, { enableTracing: false }),
    RuntimeConfigLoaderModule.forRoot({}),
    ContentModule.forRoot({
      loader: { provide: ContentService, useClass: CmsContentHalService }
    }),
    ThemeModule.forRoot({
      themeLoader: { provide: ThemeService, useClass: ThemeHalService }
    }),
    SharedModule.forRoot(),
    FontAwesomeModule,
    CommonUiModule,
    GoogleTagModule.forRoot(),
    StoreModule.forRoot(reducers, { metaReducers }),
    EffectsModule.forRoot([AppEffects]),
    ...environment.imports,
    RouterStoreModule,
    DataApiModule.forRoot({
      provide: RESPONSE_LOGGER_TOKEN,
      useClass: ResponseStoreLogger,
      multi: true
    }),
    DynamicOutletModule,
    CardCheckUiModule,
    CoreNgrxModule,
    LayoutModule,
    ApFormsModule
  ],
  providers: [
    {
      provide: AppConfig,
      useFactory: appConfigFactory,
      deps: [RuntimeConfigLoaderService]
    },
    {
      provide: MAT_LABEL_GLOBAL_OPTIONS,
      useValue: { float: 'always' }
    },
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: { appearance: 'fill' }
    },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE]
    },
    {
      provide: MAT_DATE_FORMATS,
      useValue: MY_DATE_FORMATS
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthRequestInterceptor,
      multi: true
    },
    {
      provide: RESPONSE_LOGGER_TOKEN,
      useClass: ResponseConsoleLogger,
      multi: true
    },
    {
      provide: DEBUG_INJECTION_TOKEN,
      useValue: !environment.production
    },
    {
      provide: SirenCache,
      useClass: SirenCacheNgrx
    },
    {
      provide: MENU_TOKEN,
      useClass: MenuHalService
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(
    moduleLoaderService: ModuleLoaderService,
    componentOutletRegistry: DynamicOutletRegistryService) {
    moduleLoaderService.register(MODULE_REGISTER);
    componentOutletRegistry.register(AppModule.name, COMPONENT_REGISTER);
  }

}
